import { SearchProducer } from 'searchProducers.d';
import remoteConfigDiscovery from 'json/RemoteConfig.json';
import { RemoteConfig, SearchOrganizerConfig } from 'RemoteConfig';
import { checkSimilarityWords } from 'utils/stringSimilarity';

export function getProducersRemoteConfig(
  searchTerm: string | undefined,
  searchPage: string | undefined
): SearchProducer[] {
  if (!searchTerm || (searchPage && searchPage !== '1')) return [];

  const searchOrganizers = (remoteConfigDiscovery as RemoteConfig).discovery
    ?.search?.organizer;

  if (!searchOrganizers || searchOrganizers.length === 0) return [];

  const matchingOrganizers = searchOrganizers.filter(
    (organizer: SearchOrganizerConfig) =>
      organizer.searchTerms?.some((word) =>
        checkSimilarityWords(searchTerm, word)
      ) || checkSimilarityWords(searchTerm, organizer?.data?.name)
  );

  if (matchingOrganizers.length === 0) return [];

  const matchingProducers = matchingOrganizers.map(
    (org: SearchOrganizerConfig) => org.data as SearchProducer
  );

  return matchingProducers;
}
